export const iconFontAwesomeClothingFashionHatCowboySide = (
	<i className="fa-solid fa-hat-cowboy-side"></i>
);
